import { useEffect, useState } from "react";
import { salesActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const usePinSalesOrder = () => {
    const dispatch = useAppDispatch();
    const [isPinning, setIsPinning] = useState(false);
    const [isUnpinning, setIsUnpinning] = useState(false);

    const { pinningSalesOrder, pinSalesOrderSuccess, pinSalesOrderFailure } = useAppSelector(
        (state) => state.sales
    );
    const { unpinningSalesOrder, unpinSalesOrderSuccess, unpinSalesOrderFailure } = useAppSelector(
        (state) => state.sales
    );

    const handlePin = (saleId: string) => {
        setIsPinning(true);
        dispatch(salesActions.pinSalesOrder(saleId));
    };

    const handleUnpin = (saleId: string) => {
        setIsUnpinning(true);
        dispatch(salesActions.unpinSalesOrder(saleId));
    };

    useEffect(() => {
        if (pinSalesOrderSuccess && isPinning) {
            setIsPinning(false);
        }
    }, [pinSalesOrderSuccess, isPinning]);

    useEffect(() => {
        if (pinSalesOrderFailure && isPinning) {
            setIsPinning(false);
        }
    }, [pinSalesOrderFailure, isPinning]);

    useEffect(() => {
        if (unpinSalesOrderSuccess && isUnpinning) {
            setIsUnpinning(false);
        }
    }, [unpinSalesOrderSuccess, isUnpinning]);

    useEffect(() => {
        if (unpinSalesOrderFailure && isUnpinning) {
            setIsUnpinning(false);
        }
    }, [unpinSalesOrderFailure, isUnpinning]);

    return {
        isPinning: pinningSalesOrder || isPinning,
        isUnpinning: unpinningSalesOrder || isUnpinning,
        error: pinSalesOrderFailure || unpinSalesOrderFailure,
        success: pinSalesOrderSuccess || unpinSalesOrderSuccess,
        pinSuccess: pinSalesOrderSuccess,
        unpinSuccess: unpinSalesOrderSuccess,
        handlePin,
        handleUnpin,
    };
};

export default usePinSalesOrder;
